import { ChangeDetectorRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormControl } from '@angular/forms'

import { FormAtylBase } from '../../../../../motor-form-atyl/form-atyl-base'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material';
import _ from 'lodash';

@Component({
	selector: 'atyl-form-input-checkbox',
	templateUrl: './form-input-checkbox.component.html',
	styleUrls: ['./form-input-checkbox.component.scss']
})
export class FormInputCheckBoxComponent implements OnInit {
   
	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string
	@Input() outline: any

	constructor(
		private inputLabelPipe: InputLabelPipe,
		private readonly cdr: ChangeDetectorRef,
	) {
	}

	ngOnInit(): void {
        
		this.forminput.options.values.forEach((val: any) => { 
            console.log("onCheckAll",val);
         if (val.checked==undefined)
         	val.checked=false;
      })
		
		let values = this.forminput.value
		if (values && values.length > 0) {
			values.forEach((val: any) => {
                this.forminput.options.values.forEach((val_opt: any) => { 
                    if (val_opt.value+''==val+'')
                        val_opt.checked=true;
                 });   
				(this.group.get(this.forminput.ID) as FormArray).push(new FormControl(val));
				
			})
		}
		
      
		
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}

	inputChange(event: any) {
		let checkboxContainer = event.target.previousElementSibling.previousElementSibling.previousElementSibling;
		(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
			if (ctrl.value.value == checkboxContainer.value) {
				(this.group.get(this.forminput.ID) as FormArray).controls[i].value.textValue = event.target.value
			}
		})
	}
	onCheckChange(event: any, opt: any, attachedInput?: any) {
		/* Selected */
		opt.checked = event.checked;
        if(event.checked){
			let isInArray = false;
			(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
				if(ctrl.value + '' ===  opt.value + '') {
					isInArray = true;
				}
			});

			if (!isInArray)
				(this.group.get(this.forminput.ID) as FormArray).push(new FormControl(opt.value));
        }
        /* unselected */
        else{
			(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
				if(ctrl.value + '' ===  opt.value + '') {
					// Remove the unselected element from the arrayForm
					(this.group.get(this.forminput.ID) as FormArray).removeAt(i);
				}
			});
        }
        
        console.log("onCheckChange",event,opt,this.group.get(this.forminput.ID),this.forminput)
		var ev:any= {
			event: event  as Event,
			forminput:this.forminput,
			customBehaviour:this.forminput.customBehaviour,
			control:this.group.get(this.forminput.ID)
		}
		
		this.inputTyped.emit(ev);
		
		
		/* Selected */
		/*
		if (event.checked) {
			if (opt.text && attachedInput) {
				attachedInput.removeAttribute('disabled')
			}
			// Add a new control in the arrayForm
			(this.group.get(this.forminput.ID) as FormArray).push(new FormControl({
				value: event.value,
			}))
		}
		*/
		/* unselected */
		/*
		else {
			if (attachedInput) {
				attachedInput.value = ''
				attachedInput.setAttribute('disabled', 'disabled')
			}
			(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
				if (ctrl.value.value == event.source.value) {
					// Remove the unselected element from the arrayForm
					(this.group.get(this.forminput.ID) as FormArray).removeAt(i)
				}
			})
		}
		*/
	}
	checkIfChecked(index, value) {
		let check = false
		if (this.forminput.value && this.forminput.value.length > 0) {
			this.forminput.value.forEach((val, i) => {
				if (value + '' === val + '') {
					check = true
				}
			})
		}
		return check
	}

	inputTextValue(event: any, opt: any) {
		(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
			if (ctrl.value.value == opt.value) {
				(this.group.get(this.forminput.ID) as FormArray).controls[i].value.textValue = event.target.value
			}
		})
	}
	
	onCheckAll(selected: boolean) {
    /*this.allChecked = selected;
    if (this.skill.subskills == null) {
      return;
    }*/
    console.log("onCheckAll",selected);
    this.forminput.options.values.forEach(opt => { 
        opt.checked = selected
        if (selected) {
			let isInArray = false;
			(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
				if (ctrl.value+'' === opt.value+'')
					isInArray = true;
			});
			if (!isInArray)
				(this.group.get(this.forminput.ID) as FormArray).push(new FormControl(opt.value));
		} else
			(this.group.get(this.forminput.ID) as FormArray).controls.forEach((ctrl, i) => {
				if(ctrl.value+'' === opt.value+'') {
					// Remove the unselected element from the arrayForm
					(this.group.get(this.forminput.ID) as FormArray).removeAt(i);
				}
			});
    });
    
       this.cdr.detectChanges();
    }
}
